import * as api from '../apiCallerProxy';
import { bulkOperationsApiFactory } from './bulkOperationsApiFactory';

export * from './hooks';
export default bulkOperationsApiFactory(api);
